// extracted by mini-css-extract-plugin
export default {"wrapper":"Arrow_wrapper__QCMtK","wrapperDisabled":"Arrow_wrapperDisabled__kYBN9","up":"Arrow_up__FpK+9","down":"Arrow_down__hayCQ","disabled":"Arrow_disabled__MI3N5"};